import ConfirmationModalView from './ConfirmationModal.view';

export default ConfirmationModalView;
